import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "text",
    errorMsg: "Customer Code is required.",
    required: true,
    disabled: true,
  },
  warehouses: {
    name: "warehouses",
    label: "Warehouses",
    type: "multi-select",
    errorMsg: "Warehouses is required.",
    required: true,
  },
  currencyCode: {
    name: "currencyCode",
    label: "Currency Code",
    type: "select",
  },
  creditLimit: {
    name: "creditLimit",
    label: "Credit Limit",
    type: "number",
  },
  autoCreation: {
    name: "autoCreation",
    label: "Auto vendor SKU and pack type creation",
    type: "switch",
    default: false,
  },
  serviceTaxRate: {
    name: "serviceTaxRate",
    label: "Service Tax Rate (%)",
    type: "number",
    errorMsg: "Service Tax Rate is required.",
    required: true,
  },
  defRecvWh: {
    name: "defRecvWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default receiving warehouse is required.",
    required: true,
  },
  defRecvZone: {
    name: "defRecvZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default receiving zone is required.",
    required: true,
  },
  defRecvLocation: {
    name: "defRecvLocation",
    label: "Location",
    type: "select",
    errorMsg: "Default receiving location is required.",
    required: true,
  },
  defPutawayWh: {
    name: "defPutawayWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default putaway warehouse is required.",
    required: true,
  },
  defPutawayZone: {
    name: "defPutawayZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default putaway zone is required.",
    required: true,
  },
  defPutawayLocation: {
    name: "defPutawayLocation",
    label: "Location",
    type: "select",
    //errorMsg: "Default putaway location is required.",
  },
  defTRPutawayWh: {
    name: "defTRPutawayWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default trade return putaway warehouse is required.",
    required: true,
  },
  defTRPutawayZone: {
    name: "defTRPutawayZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default trade return putaway zone is required.",
    required: true,
  },
  defTRPutawayLocation: {
    name: "defTRPutawayLocation",
    label: "Location",
    type: "select",
    errorMsg: "Default trade return putaway location is required.",
    required: true,
  },
  defShipWh: {
    name: "defShipWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default shipping warehouse is required.",
    required: true,
  },
  defShipZone: {
    name: "defShipZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default shipping zone is required.",
    required: true,
  },
  defShipLocation: {
    name: "defShipLocation",
    label: "Location",
    type: "select",
    errorMsg: "Default shipping location is required.",
    required: true,
  },
  upmBase: {
    name: "upmBase",
    label: "UPM Base (e.g. L.UOM)",
    type: "number",
    errorMsg: "UPM Base is required.",
    required: true,
    disabled: true,
  },
  baseUOM: {
    name: "baseUOM",
    label: "Base UOM",
    type: "select",
    errorMsg: "Base UOM is required.",
    required: true,
  },
  upmCase: {
    name: "upmCase",
    label: "UPM Case (e.g. EA/CTN)",
    type: "number",
  },
  caseUOM: {
    name: "caseUOM",
    label: "Case UOM",
    type: "select",
  },
  upmPallet: {
    name: "upmPallet",
    label: "UPM Pallet (e.g. EA/PLT)",
    type: "number",
    errorMsg: "UPM Pallet is required.",
    required: true,
  },
  palletUOM: {
    name: "palletUOM",
    label: "Pallet UOM",
    type: "select",
    errorMsg: "Pallet UOM is required.",
    required: true,
  },
  palletType: {
    name: "palletType",
    label: "Pallet Type",
    type: "select",
    errorMsg: "Pallet Type is required.",
    required: true,
  },
};

const {
  customerCode,
  warehouses,
  currencyCode,
  creditLimit,
  autoCreation,
  serviceTaxRate,
  defRecvWh,
  defRecvZone,
  defRecvLocation,
  defPutawayWh,
  defPutawayZone,
  defPutawayLocation,
  defTRPutawayWh,
  defTRPutawayZone,
  defTRPutawayLocation,
  defShipWh,
  defShipZone,
  defShipLocation,
  upmBase,
  baseUOM,
  upmCase,
  caseUOM,
  upmPallet,
  palletUOM,
  palletType,
} = formField;

export const form = {
  formId: "cust-wh-setting-form",
  formField,
  formRender: [
    [customerCode, warehouses],
    [currencyCode, creditLimit],
    [autoCreation],[serviceTaxRate],
    [
      { type: "title", label: "Default Receiving" },
      { type: "title", label: "Default Trade Return Putaway" },
    ],
    [defRecvWh, defTRPutawayWh],
    [defRecvZone, defTRPutawayZone],
    [defRecvLocation, defTRPutawayLocation],
    [
      { type: "title", label: "Default Putaway" },
      { type: "title", label: "Default Shipping" },
    ],
    [defPutawayWh, defShipWh],
    [defPutawayZone, defShipZone],
    [defPutawayLocation, defShipLocation],
    [{ type: "title", label: "Base Measurement" }],
    [upmBase, baseUOM],
    [{ type: "title", label: "Case Measurement" }],
    [upmCase, caseUOM],
    [{ type: "title", label: "Pallet Measurement" }],
    [upmPallet, palletUOM],
    [palletType],
  ],
};

export const formRender = [
  [customerCode, warehouses, currencyCode, creditLimit],
  [autoCreation,serviceTaxRate],
  [
    { type: "title", label: "Default Receiving" },
    { type: "title", label: "Default Putaway" },
    { type: "title", label: "Default Trade Return Putaway" },
    { type: "title", label: "Default Shipping" },
  ],
  [defRecvWh, defPutawayWh, defTRPutawayWh, defShipWh],
  [defRecvZone, defPutawayZone, defTRPutawayZone, defShipZone],
  [defRecvLocation, defPutawayLocation, defTRPutawayLocation, defShipLocation],

  [
    { type: "title", label: "Base Measurement" },
    { type: "title", label: "Case Measurement" },
  ],
  [upmBase, baseUOM, upmCase, caseUOM],
  [{ type: "title", label: "Pallet Measurement" }],
  [upmPallet, palletUOM, palletType],
];

export const initialValues = getInitialValues(formField);

export const custWhSettingValidation = Yup.object().shape({
  [customerCode.name]: Yup.string().nullable().max(20).required(customerCode.errorMsg),
  [warehouses.name]: Yup.array().min(1).required(warehouses.errorMsg),
  [serviceTaxRate.name]: Yup.number().min(1).required(serviceTaxRate.errorMsg),
  [defRecvWh.name]: Yup.string().nullable().max(20).required(defRecvWh.errorMsg),
  [defRecvZone.name]: Yup.string().nullable().max(20).required(defRecvZone.errorMsg),
  [defRecvLocation.name]: Yup.string().nullable().max(20).required(defRecvLocation.errorMsg),
  [defPutawayWh.name]: Yup.string().nullable().max(20).required(defPutawayWh.errorMsg),
  [defPutawayZone.name]: Yup.string().nullable().max(20).required(defPutawayZone.errorMsg),
  [defPutawayLocation.name]: Yup.string().nullable().max(20),
  [defTRPutawayWh.name]: Yup.string().nullable().max(20).required(defTRPutawayWh.errorMsg),
  [defTRPutawayZone.name]: Yup.string().nullable().max(20).required(defTRPutawayZone.errorMsg),
  [defTRPutawayLocation.name]: Yup.string()
    .nullable()
    .max(20)
    .required(defTRPutawayLocation.errorMsg),
  [defShipWh.name]: Yup.string().nullable().max(20).required(defShipWh.errorMsg),
  [defShipZone.name]: Yup.string().nullable().max(20).required(defShipZone.errorMsg),
  [defShipLocation.name]: Yup.string().nullable().max(20).required(defShipLocation.errorMsg),
  [upmBase.name]: Yup.number().min(1).required(upmBase.errorMsg),
  [baseUOM.name]: Yup.string().nullable().max(10).required(baseUOM.errorMsg),
  [upmCase.name]: Yup.number().min(0),
  [caseUOM.name]: Yup.string().nullable().max(10),
  [upmPallet.name]: Yup.number().min(1).required(upmPallet.errorMsg),
  [palletUOM.name]: Yup.string().nullable().max(10).required(palletUOM.errorMsg),
  [palletType.name]: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable()
    .required(),
});
